// import uuidv4 from 'uuid-v4';

export const user = {
  id: 0,
  firstName: '',
  lastName: '',
  imageUrl: '',
  email: '',
  phone: '',
  userType: {
    userType: 'User',
  },
  isVerified: false,
  isActive: false,
  verificationSentOn: '',
  lastActiveOn: '',
  teamsId: [],
  teams: [],
};

export const company = {
  id: 0,
  name: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  email: '',
  phone: '',
};

export const team = {
  id: 0, name: '', color: '', icon: '',
};

export const meeting = {
  id: 0,
  title: '',
  date: '',
  meetingType: {
    meetingType: 'Open',
  },
  shortId: '',
};
